// api status
export const make3 = name => [
  name + '_REQUEST',
  name + '_SUCCESS',
  name + '_FAIL'
]
// actions for api calling
const promiseTypes = [
  'LOAD_ESTIMATE'
].reduce((prev, cur) => {
  make3(cur).forEach(key => {
    prev[key] = key
  })

  return prev
}, {})

// actions for local data set
const simpleTypes = [
  'SET_ROUTE',
  'SET_USERINFO',
  'CLEAR_DATA'
].reduce((prev, cur) => {
  prev[cur] = cur
  return prev
}, {})

export const types = { ...simpleTypes, ...promiseTypes }
